module.exports = __webpack_public_path__ + "img/mx_logo.3b8987d6.png";